import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "components/card";
import Button from "components/button";
import { createAnnouncement } from "services/announcements";
import { getCsrfToken } from "api";

const CreateAnnouncement = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const [error, setError] = useState<string | null>(null);

  const getErrorMessage = (e: unknown) => {
    const anyE = e as any;
    // Laravel validation errors are under response.data.errors
    if (anyE?.response?.data?.errors) {
      const errs = anyE.response.data.errors;
      const first = Object.values(errs).flat()[0];
      return first || String(e);
    }
    return anyE?.response?.data?.message || anyE?.message || String(e);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      // service handles CSRF; call the service directly
      await createAnnouncement({ title, body });
      navigate("/admin/announcements");
    } catch (err) {
      console.error("Failed to create announcement", err);
      setError(getErrorMessage(err) || "Failed to create announcement");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Create Announcement</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="mt-1 block w-full rounded-md border border-gray-300 bg-white text-gray-900 placeholder-gray-400 shadow-sm dark:border-white/10 dark:bg-navy-800 dark:text-white dark:placeholder-white/40"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Body
          </label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
            rows={6}
            className="mt-1 block w-full rounded-md border border-gray-300 bg-white text-gray-900 placeholder-gray-400 shadow-sm dark:border-white/10 dark:bg-navy-800 dark:text-white dark:placeholder-white/40"
          />
        </div>
        <div>
          <Button type="submit" disabled={submitting}>
            {submitting ? "Creating..." : "Create"}
          </Button>
          {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
        </div>
      </form>
    </Card>
  );
};

export default CreateAnnouncement;
